"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderService = void 0;
const rxjs_1 = require("rxjs");
/**
 * Loader Service
 *
 * Class that controlls the visibility and availability of the loading component
 */
class LoaderService {
    constructor() {
        this.loading = false;
        this.loadingCount = 0;
        this.loadingChange = new rxjs_1.Subject();
        this.changeEvent = this.loadingChange.asObservable();
        // intentionally left blank
    }
    /**
     * @returns Keeps track of when cart has changed. This can be used to listen to changes in the cart
     */
    triggerLoadingChange() {
        this.loadingChange.next();
    }
    /**
     * @returns the value of isLoading
     */
    isLoading() {
        return this.loading;
    }
    /**
     * Increases a loading counter and shows the loader if it isn't already displayed
     */
    showLoading() {
        // increment active loader count
        this.loadingCount++;
        // if loader isn't already displayed, show it
        if (!this.loading) {
            this.loading = true;
            this.triggerLoadingChange();
        }
    }
    /**
     * Decrements a loading counter and hides the loader if there aren't any more active loading
     */
    hideLoading() {
        // decrement active loader count
        this.loadingCount--;
        // if loader is active, and no more loaders are active, hide it
        if (this.loading && this.loadingCount === 0) {
            this.loading = false;
            this.triggerLoadingChange();
        }
        // adjust final count to prevent superfluous calls to hideLoading()
        this.reconcileLoading();
    }
    /**
     * Resets the loading counter to 0 if it is ever set below 0
     */
    reconcileLoading() {
        // prevets too many calls to the loader making it go less than 0
        if (this.loadingCount < 0) {
            this.loadingCount = 0;
        }
    }
}
exports.LoaderService = LoaderService;
//# sourceMappingURL=loader.service.js.map